export default __webpack_public_path__ + "static/vifon_cieszy_miche-c83fa54111022514bf8502d79fc593d4.jpg";